import { css } from 'styled-components';

export const borderRadius = (
    topLeft = 1,
    topRight,
    bottomRight,
    bottomLeft
) => {
    if (topRight === undefined) {
        return css`
            border-radius: calc(${topLeft}em * var(--brm));
            corner-shape: superellipse(1.4);
        `;
    }

    const tl = topLeft || 0;
    const tr = topRight || 0;
    const br = bottomRight || 0;
    const bl = bottomLeft || 0;

    return css`
        border-top-left-radius: calc(${tl}em * var(--brm));
        border-top-right-radius: calc(${tr}em * var(--brm));
        border-bottom-right-radius: calc(${br}em * var(--brm));
        border-bottom-left-radius: calc(${bl}em * var(--brm));
        corner-shape: superellipse(1.4);
    `;
};

export const getColor = (colorName, opacity = 1, lightenDarken = 0) => props => {
    const theme = props.theme;
    const p3ColorName = colorName.startsWith('p') ? colorName : `p${colorName}`;
    const supportsP3 = CSS.supports('color', 'color(display-p3 1 1 1)') && theme[p3ColorName];

    if (lightenDarken === 0) {
        if (supportsP3) {
            return `color(display-p3 ${theme[p3ColorName]} / ${opacity})`;
        }
        return `rgba(${theme[colorName]}, ${opacity})`;
    }

    const rgbaValues = theme[colorName].split(',').map(v => parseFloat(v.trim()));
    const p3Values = theme[p3ColorName] ? theme[p3ColorName].split(/\s+/).map(v => parseFloat(v.trim())) : null;

    const adjustedRgba = rgbaValues.map(v => {
        if (lightenDarken < 0) {
            const percent = Math.abs(lightenDarken);
            return Math.min(255, Math.round(v + (255 - v) * (percent / 100)));
        } else {
            return Math.max(0, Math.round(v * (1 - lightenDarken / 100)));
        }
    });

    const adjustedP3 = p3Values ? p3Values.map(v => {
        if (lightenDarken < 0) {
            const percent = Math.abs(lightenDarken);
            return Math.min(1, v + (1 - v) * (percent / 100));
        } else {
            return Math.max(0, v * (1 - lightenDarken / 100));
        }
    }) : null;

    if (supportsP3 && adjustedP3) {
        return `color(display-p3 ${adjustedP3.join(' ')} / ${opacity})`;
    }
    return `rgba(${adjustedRgba.join(', ')}, ${opacity})`;
};
